import modelBase from "../model-base.model";
import loginModel from "../login.model";
import moment from "moment";
import { formats as FORMATS } from '../../config/constants';

var modifyScheduleModel = {

  formData: {},

  updateSchedule: function (successCallBack, failureCallBack) {
    let _formData = {
      scheduleID: modifyScheduleModel.formData.scheduleID,
      siteId: modifyScheduleModel.formData.siteId,
      scheduleDate: moment(modifyScheduleModel.formData.scheduleDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat),
      leaveDayOffType: modifyScheduleModel.formData.leaveDayOffType,
      startTime: modifyScheduleModel.formData.startTime,
      endTime: modifyScheduleModel.formData.endTime,
      timeRequiredYN: modifyScheduleModel.formData.startTime && modifyScheduleModel.formData.startTime.length > 0 ? 'Y' : 'N',
      breakHour: modifyScheduleModel.formData.breakHour,
      breakHourRequiredYN: !modifyScheduleModel.formData.breakHour || modifyScheduleModel.formData.breakHour === '00:00' ? 'N' : 'Y',
      remarks: modifyScheduleModel.formData.remarks,
      action: 'U', // A - Approve, U - Update, R - Reject, C - Cancel, W - Withdraw
    }
    console.log('saving... formData: ', JSON.parse(JSON.stringify(_formData)));
    modelBase.post(successCallBack, failureCallBack, `/api/schedule/edit/${_formData.scheduleID}`, { body: _formData });
  },

  cancelSchedule: function (successCallBack, failureCallBack) {
    let _formData = {
      scheduleID: modifyScheduleModel.formData.scheduleID,
      supervisorRemarks: modifyScheduleModel.formData.supervisorRemarks,
      action: 'C', // A - Approve, U - Update, R - Reject, C - Cancel, W - Withdraw
    }
    console.log('cancelling... formData: ', JSON.parse(JSON.stringify(_formData)));
    modelBase.post(successCallBack, failureCallBack, `/api/schedule/edit/${_formData.scheduleID}`, { body: _formData });
  },

  getManagedSiteList: function (successCallBack, failureCallBack, filter) {
    modelBase.get(successCallBack, failureCallBack, `/api/site/managed/${filter.countryCode}/${filter.userId}`);
  },
  
  getLeaveTypeList: function (successCallBack, failureCallBack) {
    const countryCode = loginModel.credentials.country;
    modelBase.get(successCallBack, failureCallBack, `/api/codemaster/leavetype?countryCode=${countryCode}`);
  },
  
  getDayOffTypeList: function (successCallBack, failureCallBack) {
    const countryCode = loginModel.credentials.country;
    modelBase.get(successCallBack, failureCallBack, `/api/codemaster/dayofftype?countryCode=${countryCode}`);
  },

  resetFormDataObj: function(scheduleObj) {
    modifyScheduleModel.formData = {
      _breakHour: '00',
      _breakMinute: '00',
      get hourOfBreakHour() {
        return this._breakHour;
      },
      set hourOfBreakHour(hr){
        hr = parseInt(hr);
        if (isNaN(hr)) {
          this._breakHour = '00';
        } else {
          hr = hr > 23 ? '0' : hr < 0 ? '23' : hr;
          this._breakHour = _.padStart(hr, 2, '0');
        }
      },
      get minuteOfBreakHour() {
        return this._breakMinute;
      },
      set minuteOfBreakHour(mn){
        mn = parseInt(mn);
        if (isNaN(mn)) {
          this._breakMinute = '00';
        } else {
          mn = mn > 59 ? '0' : mn < 0 ? '59' : mn;
          this._breakMinute = _.padStart(mn, 2, '0');
        }
      },
      get breakHour() {
        return this.hourOfBreakHour.toString() + ':' + this.minuteOfBreakHour.toString();
      },
      set breakHour(time){
        if (time && time.toString().includes(":")) { // check if param is HH:mm format
          this.hourOfBreakHour = time.split(":")[0]; // get HH
          this.minuteOfBreakHour = time.split(":")[1]; // get mm
        }
      }
    };

    modifyScheduleModel.formData.scheduleID = scheduleObj.scheduleID;
    modifyScheduleModel.formData.siteId = scheduleObj.siteId;
    modifyScheduleModel.formData.scheduleDate = scheduleObj.scheduleDate; // YYYY.MM.DD
    modifyScheduleModel.formData.leaveDayOffType = scheduleObj.leaveDayOffType;
    modifyScheduleModel.formData.startTime = scheduleObj.startTime; // HH:mm
    modifyScheduleModel.formData.endTime = scheduleObj.endTime; // HH:mm
    modifyScheduleModel.formData.timeRequiredYN = scheduleObj.timeRequiredYN;
    modifyScheduleModel.formData.breakHour = scheduleObj.breakHour;
    modifyScheduleModel.formData.breakHourRequiredYN = scheduleObj.breakHourRequiredYN;
    modifyScheduleModel.formData.remarks = scheduleObj.remarks;
    modifyScheduleModel.formData.supervisorRemarks = ''; // For Cancel function only
  },

}

export default modifyScheduleModel;
